import type { RoundState } from '@magic/slot';

export const baseRound: RoundState[] = [
    {
        index: 0,
        type: 'reveal',
        board: [
            [
                {
                    name: 'H4',
                },
                {
                    name: 'S',
                    scatter: true,
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'S',
                    scatter: true,
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
            ],
            [
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'H4',
                },
            ],
            [
                {
                    name: 'H3',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'S',
                    scatter: true,
                },
                {
                    name: 'L2',
                },
            ],
        ],
        paddingPositions: [111, 160, 13, 73, 99],
        gameType: 'basegame',
        anticipation: [0, 0, 1, 2, 3],
    },
    {
        index: 1,
        type: 'setTotalWin',
        amount: 0,
    },
    {
        index: 2,
        type: 'finalWin',
        amount: 0,
    },
];
